<li (click)="onTabClicked()">{{tab.i18n|translate}}</li>
